import React, { FC, useEffect, useState } from 'react';
import { useAuth } from '../../../../hooks/useAuth';
import Button from '../../../../kit/Button';
import Form from '../../../../kit/Form';
import { toast } from '../../../../kit/NotificationCenter';

const ShareLink: FC<{ onCopy?: () => void }> = ({ onCopy }): JSX.Element => {
    const auth = useAuth();
    const [ code, setCode ] = useState<string>('');

    useEffect(() => {
        if (!auth || !auth.restaurant) return;
        const url = `${window.location.origin}/restaurants/profile/${auth.restaurant.id}/timeslots/now`;
        setCode(`<div id="easyzeats-widget" data-restaurant="${auth.restaurant.key}"></div>\n<script src="${process.env.REACT_APP_API_URl?.replace('/api', '/widget')}"></script>`);
    }, [auth]);

    const handleCopy = (txt: string): void => {
        navigator.clipboard.writeText(txt);
        toast({ content: 'De embed code is gekopieerd naar het klembord.' });
        if (onCopy) {
            onCopy();
        }
    }

	return (<>
		<p className="sv-description">
            Gebruik een simpele HTML module waarmee gasten en bezoekers direct kunnen reservering via jouw website.
        </p>
        <Form.Textarea
            readOnly
            rows={5}
			value={code}
        />
		<Button
			block
            color="green"
            label="Kopieer"
            onClick={() => handleCopy(code)}
			style={{ marginTop: 32 }}
        />
        <Button
			block
            color="grey"
            label="Hulp nodig?"
            href="/dashboard/settings/contact"
        />
    </>);
}

export default ShareLink;
